'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.withFeatureFlags = undefined;

var _launchdarklyReactClientSdk = require('launchdarkly-react-client-sdk');

var _launchDarkly = require('../config/data/launch-darkly');

var _env = require('../helpers/env');

var withFeatureFlags = exports.withFeatureFlags = function withFeatureFlags(Component) {
    return (0, _launchdarklyReactClientSdk.withLDProvider)({
        clientSideID: _launchDarkly.launchDarklyClientSideIds[(0, _env.getDomain)()],
        reactOptions: {
            useCamelCaseFlagKeys: false
        }
    })(Component);
};
//# sourceMappingURL=with-feature-flags.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/feature-flags/with-feature-flags.js
// module id = 1984
// module chunks = 0